module.exports = __webpack_public_path__ + "img/line.a92b8161.svg";